import child from '../../../../general/child';

import type { TypeUploadItemTextCustom } from '../types';

// ----------------------------------------------------------------------------

function setUploadItemText(element: HTMLElement | undefined, value: string, custom?: TypeUploadItemTextCustom): void {
    if (!element) {
        return;
    }

    // Static markup is owned by the caller — leave the content untouched.
    if (custom !== undefined && typeof custom !== 'function') {
        return;
    }

    if (typeof custom === 'function') {
        element.innerHTML = '';

        // An empty value keeps the element empty, so `:empty` rules still apply.
        if (value !== '') {
            child(element, custom(value));
        }

        return;
    }

    element.textContent = value;
}

// ----------------------------------------------------------------------------

export default setUploadItemText;
